import { render, staticRenderFns } from "./AcessarAtaView.vue?vue&type=template&id=62e82674"
import script from "./AcessarAtaView.vue?vue&type=script&lang=js"
export * from "./AcessarAtaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports